(function () {
    "use strict";

    // Get this browser's take on how it will tell us what transparent is. Some browsers are "transparent", some are "rgb(0, 0, 0, 0)", etc.
    // Must be appended else Chrome etc return 'initial'
    var tempDiv = $('<div style="background:none;display:none;"/>').appendTo('body');
    var transparent = tempDiv.css('backgroundColor');
    tempDiv.remove();

    //
    // When you ask for the background-color of an element it doesnt give you the color the user would see, but
    // the effective css color for the element.  So if its transparent, you get transparent - not whats behind it.
    // This returns the color the user would actually see on the screen.
    //
    jQuery.fn.visibleBackgroundColor = function () {
        var element = this;

        function isTransparent(color) {
            if (color == transparent) {
                return true;
            }

            if (color == "transparent") {
                return true;
            }

            if (color.startsWith("rgba") && color.endsWith("0)")) {
                return true;
            }

            return false;
        }

        while (!element.is('body')) {

            var backgroundColor = element.css('backgroundColor');

            if (isTransparent(backgroundColor)) {
                element = element.parent();
            }
            else {
                return backgroundColor;
            }
        }

        return "#FFF";
    };

})();